export default __webpack_public_path__ + "static/media/token_tier.64152c1c.png";